import { useEffect, useState } from "react";
import { Card, Grid } from "@mui/material";
import { t } from "i18next";
import ApiUrls from "../../../../../../helpers/urls/ApiUrls";
import AppConfig from "../../../../../../helpers/constants/AppConfig";
import MDBox from "../../../../../../components/MDs/MDBox";
import MDTypography from "../../../../../../components/MDs/MDTypography";
import DataTable from "../../../../../../components/Tables/DataTable";
import DeleteButton from "../../../../../../components/DeleteButton";
import EditIPGroup from "./EditIPGroup";

function IPGroupList({ list, setEditIP, getList }) {
  const [rows, setRows] = useState([]);
  const columns = [
    { Header: t("user.name"), accessor: "name", align: "left" },
    { Header: t("report.cidr"), accessor: "cidr", align: "center" },
    { Header: t("global.edit"), accessor: "edit", align: "center", width: '10%' },
    { Header: t("global.delete"), accessor: "delete", align: "center", width: '10%' }
  ];

  useEffect(() => {
    if (list) {
      setDataList();
    }
  }, [list]);

  const setDataList = () => {
    const temp_rows = list.map((c) => {
      return (
        {
          name: (<div className="font-weight-bold">{c.name}</div>),
          cidr: returnIPs(c.cidr),
          edit: (<EditIPGroup ipGroup={c} setEditIP={setEditIP} />),
          delete: (
            <DeleteButton
              item={c}
              itemName={t("report.ip_group")}
              deleteUrl={ApiUrls.ip_group.delete}
              handleCloseModal={handleCloseModal}
            />
          )
        }
      )});

    setRows(temp_rows);
  }

  const returnIPs = (ips) => {
    let ipgs = [];
    for (let i = 0; i < ips.length; i++) {
      let ip = ips[i];
      if (i === 1 && i < ips.length - 1) {
        ip += " ...";
      }
      ipgs.push(ip);

      if (i === 1) {
        break;
      }
    }

    return (
      <div className="ltr-div">
        {ipgs.map((d, i) => {
          return (
            <div key={`ipgs-${i}`}>{d}</div>
          );
        })}
      </div>
    )
  }

  const handleCloseModal = () => {
    getList();
  }

  return (
    <Grid item xs={12} mt={3}>
      <Card>
        <MDBox
          mx={2}
          py={3}
          px={2}
          variant="gradient"
          bgColor={AppConfig.color}
          borderRadius="lg"
          className="table-with-button flex-column-md"
        >
          <MDTypography variant="h6" color="white">
            {t("page.list", { item: t("report.ip_group") })}
          </MDTypography>
        </MDBox>

        <MDBox pt={3}>
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            noEndBorder
            showTotalEntries={false}
            entriesPerPage={{ defaultValue: 5 }}
          />
        </MDBox>
      </Card>
    </Grid>
  );
}

export default IPGroupList;
